import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Referral from "../../components/Referral/Referral";


const ReferralPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        

        {/* UsersListLayer */}
        <Referral/>



    </>
  );
};

export default ReferralPage; 